<template>
    <div class="modal-overlay" v-if="otpModal" @click.self="save">
        <div class="modal-container">
            <div class="modal-content">
                    <div class="modal-header" style="background-color:black;">
                        <h5 class="modal-title" id="messageModalLabel" style="color:white;">Megabull Platform Disclaimer
                        </h5>
                    </div>
                    <div class="modal-body" style="color:red;">
                        <p>
                            Megabull is a paper trading platform designed solely for educational purposes. We provide
                            delayed market data, and no real-time trading is available. There are no investment-related
                            activities or monetary benefits associated with this application.
                            We do not offer investment advice or endorse any investment strategies. If anyone contacts
                            you claiming to provide investment services or advice under the Megabull name, please be
                            aware that Megabull is not responsible for such activities and holds no liability for them.
                            We urge you to report any such incidents immediately to our support team at
                            support@megabull.in.
                        </p>
                      <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" v-model="ignoreAlert">
                      <label class="form-check-label" for="flexCheckDefault" style="color:black;">
                        Do not show this alert Again
                      </label>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-dark" @click="save"
                            data-bs-dismiss="modal">I UNDERSTAND</button>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
export default {
  name: 'Alert',
  components: {
  },
  data () {
    return {
      otpModal: true,
      ignoreAlert: false
    }
  },
  created () {
    var alert = localStorage.getItem('ignoreAlert')
    if (alert) { this.otpModal = false }
  },
  methods: {
    save: function () {
      this.otpModal = false
      sessionStorage.setItem('alert', true)
      if (this.ignoreAlert) { localStorage.setItem('ignoreAlert', true) }
    }
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-container {
  background-color: var(--bs-body-bg);
  border-radius: 10px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  max-width: 600px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  margin: 20px;
  padding: 15px;
}

.modal-content {
  border: none;
  background-color: var(--bs-body-bg);
}
</style>



// WEBPACK FOOTER //
// src/components/profile/Alert.vue